module.exports = __webpack_public_path__ + "static/media/carta_46.a1e160cc.jpg";